import { request } from '@/shared/api/request'

export const getFileInfo = () => request({ url: `file/free/agreements`, method: 'GET'})

export const getFileByIdInfo = (id) => request({ url: `file/free/download/${id}`, method: 'GET', responseType: 'blob',})
